import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import DialogContentText from '@mui/material/DialogContentText';
import { useLocation } from 'react-router-dom';
import Draggable from 'react-draggable';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper } from '@mui/material';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const AlertDialog = ({ alert, onClose }) => {

    const message = Array.isArray(alert?.message)
        ? alert.message.join('\n')
        : alert?.message;

    const lines = message?.split('\n');

    const location = useLocation();

    useEffect(() => {
        onClose();
    }, [location.pathname]);

    return (
        <Dialog
            open={alert !== null}
            onClose={onClose}
            maxWidth='md'
            PaperComponent={PaperComponent}
            BackdropProps={{
                sx: {
                    backgroundColor: "rgba(0, 0, 0, 0.2)", // Darker backdrop
                },
            }}
        >
            <DialogTitle id="dialog-title" sx={{ cursor: 'move' }}>{alert?.title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {lines?.map((line, index) => (
                        <Typography key={index}>{line}</Typography>
                    ))}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Ok</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AlertDialog;
